import { render } from "./StateTag.vue?vue&type=template&id=0f72b2ba&scoped=true&ts=true"
import script from "./StateTag.vue?vue&type=script&lang=ts"
export * from "./StateTag.vue?vue&type=script&lang=ts"

import "./StateTag.vue?vue&type=style&index=0&id=0f72b2ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f72b2ba"]])

export default __exports__